import React from "react";
const {
  Provider: FormProvider,
  Consumer: FormConsumer
} = React.createContext({});
export {
  FormConsumer as F,
  FormProvider as a
};
